<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Data Pelanggan</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formApplicationActive=!formApplicationActive">Tambah Pelanggan Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formApplicationActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Pelanggan Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Nama <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.application_name"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">CID <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.id_client"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Telepon </label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.phone_number"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">NIK </label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.nik"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Email </label>
								<input type="email" class="form-control w-100 rounded"
								       v-model="newApplication.email"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Status Domisili</label>
								<smart-select name="address_status" :options="statusOptions"
								              v-on:update="updateNewStatus"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Alamat Domilisi </label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newApplication.address_1"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Alamat KTP </label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newApplication.address_2"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Longitude </label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.longitude"/>
							</div>
							<div class="col-12 col-md-6 col-lg-6 mt-2">
								<label class="d-block">Latitude </label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.latitude"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newApplicationSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Pelanggan Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewApplication">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorApplicationList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewApplication">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewApplication">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
						<datatable :currentIdx="currentPage" :datas="applications" :structure="applicationTableStructure"
						           :init="loadData"
						           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
						           use-seeker seeker-url="/api/master/seeker/applications"
						           @refetch="(row)=>{rowLimit=row;getApplications()}"
						           @searching="(val)=>!val.status?getApplications():applications=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<br>
											<b class="py-0 mx-0" style="font-size:20pt">
												{{ obj.application_name ? obj.application_name : "-" }}
											</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">CID :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.id_client ? obj.id_client : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Telepon :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.phone_number ? obj.phone_number : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">NIK :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.nik ? obj.nik : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Email :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.email ? obj.email : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Alamat Domilisi :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.address_1 ? obj.address_1 : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Alamat KTP :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.address_2 ? obj.address_2 : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Status Domilisi :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.address_status ? obj.address_status : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Longitude :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.longitude ? obj.longitude : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Latitude :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.latitude ? obj.latitude : "-" }}
											</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-edit-application class="btn btn-info mr-2"
											          v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.application_name ? obj.application_name : "-" }}</td>
							<td v-if="!isMobile">{{ obj.id_client ? obj.id_client : "-" }}</td>
							<td v-if="!isMobile">{{ obj.phone_number ? obj.phone_number : "-" }}</td>
							<td v-if="!isMobile">{{ obj.nik ? obj.nik : "-" }}</td>
							<td v-if="!isMobile">{{ obj.email ? obj.email : "-" }}</td>
							<td v-if="!isMobile">{{ obj.address_1 ? obj.address_1 : "-" }}</td>
							<td v-if="!isMobile">{{ obj.address_2 ? obj.address_2 : "-" }}</td>
							<td v-if="!isMobile">{{ obj.address_status ? obj.address_status : "-" }}</td>
							<td v-if="!isMobile">{{ obj.longitude ? obj.longitude : "-" }}</td>
							<td v-if="!isMobile">{{ obj.latitude ? obj.latitude : "-" }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-application class="btn btn-info mr-2 mb-1"
								          v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" 
								          class="btn btn-danger mr-2 mb-1">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-application" title="Edit Nama Pelanggan"
				         scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&applications.length>0">
						<b-row class="mt-3 pt-1" v-if="applications[selectedApplication]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Nama</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].application_name"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">CID</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].id_client"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Telepon</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].phone_number"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">NIK</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].nik"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Email</label>
								<input type="email" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].email"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Status Domisili</label>
								<smart-select name="address_status" usedefault
							              :default-value="translatePacket(applications[selectedApplication].address_status)"
							              :options="statusOptions"
							              v-on:update="(value)=>{applications[selectedApplication].address_status=value}"></smart-select>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Alamat Domisili</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="applications[selectedApplication].address_1"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Alamat KTP</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="applications[selectedApplication].address_2"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Longitude</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].longitude"/>
							</b-col>
							<b-col cols="12" md="6" lg="6">
								<label class="d-block">Latitude</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="applications[selectedApplication].latitude"/>
							</b-col>

							<b-col cols="12" class="my-3 text-right" v-if="updateApplicationState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateApplicationSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data aplikasi.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorApplicationSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data aplikasi.
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateApplicationData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateApplicationState&&!updateApplicationState)?$bvModal.hide('modal-edit-application'):''">
								Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/applications/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Nama: {{ itemToDelete.application_name }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			//step 1 edit
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Pelanggan Baru.",
			errorMessages: [],
			itemToDelete: {},
			applications: [],
			searchValue: "",
			loadData: true,
			savingNewApplication: false,
			errorNewApplication: false,
			errorApplicationList: [],
			errorApplicationSaved: false,
			newApplicationSaved: false,
			updateApplicationState: false,
			updateApplicationSaved: false,
			selectedApplication: 0,
			selectedTab: 0,
			updateApplicationCol: 6,
			newApplication: {
				application_name: ""
			},
			formApplicationActive: false,
			applicationTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Nama", key: null},
				{label: "CID", key: null},
				{label: "Telepon", key: null},
				{label: "NIK", key: null},
				{label: "Email", key: null},
				{label: "Alamat Domilisi", key: null},
				{label: "Alamat KTP", key: null},
				{label: "Status Domisili", key: null},
				{label: "Longitude", key: null},
				{label: "Latitude", key: null},
				{label: "Tindakan", key: null}
			],
			statusOptions: [
				{label: "Milik Pribadi", value: "Milik Pribadi"},
				{label: "Sewa / Kontrak", value: "Sewa / Kontrak"}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("user page");
		this.getApplications();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		translatePacket(role) {
			var label = "";
			switch (role) {
				case "Milik Pribadi":
					label = "Milik Pribadi";
					break;
				case "Sewa / Kontrak":
					label = "Sewa / Kontrak";
					break;
			}
			return label;
		},
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/applications?limit=" + this.rowLimit + "&page=" + myParams;
			this.getApplications(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getApplications();
			}
		},
		getApplications(url = (this.$baseUrl + "/api/master/applications?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log("get di sini");
				console.log(result.data.data.data);
				this.prevUrl = result.data.data.prev_page_url;
				this.nextUrl = result.data.data.next_page_url;
				this.currentPage = result.data.data.current_page;
				this.perPage = parseInt(result.data.data.per_page);
				this.applications = result.data.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewApplication() {
			this.savingNewApplication = true;
			this.errorNewApplication = false;
			console.log(this.newApplication);
			axios.post(
				this.$baseUrl + "/api/master/applications",
				{
					"application_name": this.newApplication.application_name,
					"id_client": this.newApplication.id_client,
					"phone_number": this.newApplication.phone_number,
					"nik": this.newApplication.nik,
					"email": this.newApplication.email,
					"address_status": this.newApplication.address_status,
					"address_1": this.newApplication.address_1,
					"address_2": this.newApplication.address_2,
					"longitude": this.newApplication.longitude,
					"latitude": this.newApplication.latitude,
				},
				{
					"headers":
						{
							"Authorization": "Bearer " + localStorage.getItem("accessToken")
						}
				}
			).then((result) => {
				console.log(result);
				this.getApplications();
				this.savingNewApplication = false;
				this.newApplicationSaved = true;
				this.resetForm();
				setTimeout(() => {
					this.newApplicationSaved = false;
					this.formApplicationActive = false;
				}, 1000);

			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorApplicationList = [];
				this.errorApplicationList = Object.values(err.response.data.errors);
				console.log(this.errorApplicationList);
				this.errorNewApplication = true;
				this.savingNewApplication = false;
			});
		},
		resetForm() {
			this.newApplication.application_name = "";
			this.newApplication.phone_number = "";
			this.newApplication.id_client = "";
			this.newApplication.nik = "";
			this.newApplication.email = "";
			this.newApplication.address_status = "";
			this.newApplication.address_1 = "";
			this.newApplication.address_2 = "";
			this.newApplication.longitude = "";
			this.newApplication.latitude = "";
		},
		newUsernameChange() {
			this.newApplication.password = this.newApplication.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newApplication.role = newValue;
		},
		setNewClientId(newId) {
			this.newApplication.clientId = newId;
			console.log(this.newApplication.clientId);
		},
		updateNewStatus(data) {
			this.newApplication.address_status = data;
		},
		updateApplicationData() {
			console.log("updating data");
			this.updateApplicationState = true;
			this.errorApplicationSaved = false;
			axios.put(this.$baseUrl + "/api/master/applications/" + this.applications[this.selectedApplication].id,{
						application_name: this.applications[this.selectedApplication].application_name,
						id_client: this.applications[this.selectedApplication].id_client,
						phone_number: this.applications[this.selectedApplication].phone_number,
						nik: this.applications[this.selectedApplication].nik,
						email: this.applications[this.selectedApplication].email,
						address_status: this.applications[this.selectedApplication].address_status,
						address_1: this.applications[this.selectedApplication].address_1,
						address_2: this.applications[this.selectedApplication].address_2,
						longitude: this.applications[this.selectedApplication].longitude,
						latitude: this.applications[this.selectedApplication].latitude
					},{
				          "headers": {
					          "Authorization": "Bearer " + localStorage.getItem("accessToken")
				          }
			          }
			).then((result) => {
				if (result.status == 200) {
					this.updateApplicationState = false;
					this.updateApplicationSaved = true;
					//step 4 edit
					this.dataEdit = this.applications[this.selectedApplication];
					setTimeout(() => {
						this.updateApplicationSaved = false;
						this.$bvModal.hide("modal-edit-application");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateApplicationState = false;
				this.errorApplicationSaved = true;
				console.log(err.response);
			});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.applications, this.selectedApplication, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateApplicationState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-application");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/bank/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;
					this.users.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1500);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
::v-deep .modal-content {
	margin: -3.25rem auto;
}

.btn {
	padding: 2px 6px;
}
</style>
